import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M38 18.968c0-3.338-.063-6.048-.189-8.136a7 7 0 0 0-6.363-6.55C29.347 4.094 26.865 4 24 4c-2.868 0-5.352.094-7.454.282a7 7 0 0 0-6.363 6.566c-.122 2.1-.183 4.838-.183 8.217 0 7.37.29 15.962.867 25.775a2 2 0 0 0 3.411 1.296l8.163-8.163c.612-.611.857-.777 1.18-.876.254-.076.504-.076.757 0 .324.099.57.265 1.181.876l8.16 8.16a2 2 0 0 0 3.41-1.3c.58-10.075.871-18.696.871-25.865Zm-2.185-8.016c.123 2.043.185 4.716.185 8.016 0 7.127-.289 15.71-.867 25.75l-8.16-8.159c-.825-.825-1.333-1.17-2.015-1.375a3.27 3.27 0 0 0-1.916 0c-.682.206-1.19.55-2.015 1.375l-8.163 8.163C12.288 34.946 12 26.393 12 19.065c0-3.344.06-6.045.18-8.1a5 5 0 0 1 4.545-4.69C18.762 6.091 21.188 6 24 6c2.81 0 5.233.091 7.27.274a5 5 0 0 1 4.545 4.678Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Bookmark-Outlined_svg__a",
      width: 28,
      height: 43,
      x: 10,
      y: 4,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M38 18.968c0-3.338-.063-6.048-.189-8.136a7 7 0 0 0-6.363-6.55C29.347 4.094 26.865 4 24 4c-2.868 0-5.352.094-7.454.282a7 7 0 0 0-6.363 6.566c-.122 2.1-.183 4.838-.183 8.217 0 7.37.29 15.962.867 25.775a2 2 0 0 0 3.411 1.296l8.163-8.163c.612-.611.857-.777 1.18-.876.254-.076.504-.076.757 0 .324.099.57.265 1.181.876l8.16 8.16a2 2 0 0 0 3.41-1.3c.58-10.075.871-18.696.871-25.865Zm-2.185-8.016c.123 2.043.185 4.716.185 8.016 0 7.127-.289 15.71-.867 25.75l-8.16-8.159c-.825-.825-1.333-1.17-2.015-1.375a3.27 3.27 0 0 0-1.916 0c-.682.206-1.19.55-2.015 1.375l-8.163 8.163C12.288 34.946 12 26.393 12 19.065c0-3.344.06-6.045.18-8.1a5 5 0 0 1 4.545-4.69C18.762 6.091 21.188 6 24 6c2.81 0 5.233.091 7.27.274a5 5 0 0 1 4.545 4.678Z",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Bookmark-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgBookmarkOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BookmarkOutlined_default = SvgBookmarkOutlined;

export { BookmarkOutlined_default as default };
